var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon__phone",
  fill: "none",
  viewBox: "0 0 10 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M8.117 0h-6.92C.575 0 .064.511.064 1.133v13.734C.064 15.49.575 16 1.197 16h6.92c.621 0 1.132-.511 1.132-1.133V1.133A1.134 1.134 0 0 0 8.117 0Zm-3.46 15.03a.711.711 0 0 1-.71-.71c0-.39.32-.709.71-.709.39 0 .71.319.71.71 0 .39-.32.71-.71.71Zm3.71-2.418H.947V1.758H8.37l-.003 10.854Z",
  clipRule: "evenodd"
})));
export default SvgPhone;